var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Platform, StyleSheet, View } from 'react-native';
import { theme } from '@xbto/design-system';
import { Col, TextBody } from '../../atoms';
export function DropdownContainer(_a) {
    var { align = 'left' } = _a, rest = __rest(_a, ["align"]);
    return (_jsx(Col, Object.assign({}, rest, { style: [$.container, { zIndex: 1 }, align === 'right' && { right: '0' }] })));
}
export function DropdownItem({ label }) {
    return (_jsx(View, { style: $.item, children: _jsx(TextBody, { color: "primary", numberOfLines: 1, children: label }) }));
}
// Approximating: box-shadow: 0px 0px 10px 2px #00000012;
const shadowColor = '#000';
const shadowStyle = Platform.select({
    ios: {
        shadowColor,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.07,
        shadowRadius: 12,
    },
    android: {
        elevation: 4,
        shadowColor,
    },
    web: {
        boxShadow: '0px 0px 10px 2px #00000012',
    },
});
const $ = StyleSheet.create({
    container: Object.assign({ marginTop: theme.spacing['1'], borderWidth: 1, borderColor: theme.color.border.primary, borderRadius: theme.radius.sm, backgroundColor: theme.color.background.white, position: 'absolute', maxHeight: 240, overflow: 'scroll' }, shadowStyle),
    item: {
        marginTop: -1,
        paddingVertical: theme.spacing['4'],
        paddingHorizontal: theme.spacing['6'],
        borderTopWidth: 1,
        borderTopColor: theme.color.border.primary,
        cursor: 'pointer',
    },
});
